var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tax-row__container"},[_c('p',[_vm._v(_vm._s(_vm.tax.name))]),_c('p',{attrs:{"data-cy":("tax-" + (_vm.tax.name) + "-value")}},[_vm._v(_vm._s(_vm.tax.value)+_vm._s(_vm.taxUnit))])])}
var staticRenderFns = []

export { render, staticRenderFns }